import { IAction, StateStatus } from '../../utils/common';
import * as Types from './types';

interface IState {
  memberStateList: any;
  countriesList: any;
  memberStateExcludeCyprusList: any;
  registrationRequest: StateStatus | null | undefined;
  vatReturnRequest: StateStatus | null | undefined;
}

const initialState: IState = {
  memberStateList: {
    status: null,
    data: null,
  },
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  countriesList: {
    status: null,
    data: null,
  },
  registrationRequest: null,
  vatReturnRequest: null,
};

const RequestReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_MEMBER_STATE:
      return {
        ...state,
        memberStateList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_ALL_COUNTRIES:
      return {
        ...state,
        countriesList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_REGISTRATION_REQUEST:
      return {
        ...state,
        registrationRequest: action.status,
      };
    case Types.SET_VATRETURN_REQUEST:
      return {
        ...state,
        vatReturnRequest: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default RequestReducer;
